var map = {
	"./Header-Background-bottom_.png": "c44c",
	"./Header-Background-top_.png": "9249",
	"./bg-portal.png": "81b1",
	"./bg-support-rounded.png": "a623",
	"./filter.png": "edb6",
	"./icon-amount-hospital.png": "86a9",
	"./icon-amount-support.png": "b0dd",
	"./icon-average-support.png": "cf8c",
	"./icon-doc.png": "6cf9",
	"./icon-file-text.png": "9068",
	"./icon-settings.png": "d836",
	"./icon.png": "f8a2",
	"./icon/Icon-Manual.png": "d088",
	"./icon/Union.png": "9889",
	"./icon/Union_blue.png": "fdec",
	"./icon/Vector.png": "b790",
	"./icon/airplay.png": "591e",
	"./icon/arrow-down.png": "9c70",
	"./icon/arrow-up.png": "4ed5",
	"./icon/asc.png": "3ce6",
	"./icon/bar-chart-2.png": "1cda",
	"./icon/bills.png": "3ec9",
	"./icon/book-open.png": "07ce",
	"./icon/briefcase.png": "0be1",
	"./icon/calendar.png": "6249",
	"./icon/ceklis.png": "d56f",
	"./icon/clipboard.png": "c510",
	"./icon/desc.png": "c716",
	"./icon/file-text-blue.png": "d7d3",
	"./icon/file-text-white.png": "2e86",
	"./icon/file-text.png": "277f",
	"./icon/filter.png": "eda3",
	"./icon/git-pull-request.png": "f2e1",
	"./icon/globe.png": "0b54",
	"./icon/help-circle-white.png": "6961",
	"./icon/help-circle.png": "68e8",
	"./icon/icon-approval.png": "5a0f",
	"./icon/icon-download.png": "a9be",
	"./icon/icon-reject.png": "0069",
	"./icon/icon-video.png": "11c8",
	"./icon/info.png": "261e",
	"./icon/location-blue.png": "7647",
	"./icon/location.png": "7f4a",
	"./icon/mail.png": "4f51",
	"./icon/minimize-2.png": "9079",
	"./icon/pie-chart.png": "7cfc",
	"./icon/settings.png": "5e20",
	"./icon/target.png": "2536",
	"./logo-white.png": "06f1",
	"./logo.png": "9d64",
	"./navbar/bar-chart-2.png": "16bd",
	"./navbar/bar-chart.png": "3caa",
	"./navbar/calendar.png": "06de",
	"./navbar/clipboard-2.png": "ad0f",
	"./navbar/clipboard.png": "d8d4",
	"./navbar/file-text.png": "67b4",
	"./navbar/globe-2.png": "df9c",
	"./navbar/po-monitoring.png": "87d5",
	"./navbar/roi.png": "f4a2",
	"./navbar/spending-2.png": "3f2f",
	"./navbar/spending.png": "d29d",
	"./navbar/tool.png": "050d",
	"./navbar/tools.png": "5ff3",
	"./navbar/trending-up.png": "e78e",
	"./taxonomy-table.png": "bebf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";